const styles = theme => ({
  container: {
    // Instead of a fixed height, allow it to grow:
    // height: "10.3vh",
    height: "10.3vh",

    display: "flex"
    // position: "relative",
    // If you want the container to stack items vertically, use:
    // flexDirection: "column",
  },
  left: {
    flexBasis: "100%",
    backgroundColor: "rgba(255,255,255,0.18)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    opacity: 0,
    transition: theme.transitions.create("opacity", {
      easing: theme.transitions.easing.sharp,
      duration: ".5s"
    })
  },
  leftIn: {
    opacity: 1,
    borderTop: ".5px solid rgba(255,255,255,0.6)",
    borderBottom: ".5px solid rgba(255,255,255,0.6)",
    borderLeft: "1px solid rgba(255,255,255,0.6)",
    borderRight: "1px solid rgba(255,255,255,0.6)"
  },
  number: {
    fontFamily: "Oswald",
    fontWeight: 500,
    fontSize: "4rem",
    color: theme.palette.common.white,
    display: "flex",
    justifyContent: "center"
  },
  right: {
    flexGrow: 1,
    textAlign: "left",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: theme.spacing.unit * 2,
    opacity: 0,
    transition: theme.transitions.create(["opacity", "padding-left"], {
      easing: theme.transitions.easing.sharp,
      duration: ".5s"
    })
  },
  rightIn: {
    paddingLeft: theme.spacing.unit * 6,
    opacity: 1
  },
  name: {
    // marginLeft: "24px",
    marginBottom: "5px",
    fontFamily: "Oswald",
    color: theme.palette.common.white,
    fontWeight: 400,
    fontStyle: "italic",
    fontSize: "1.8rem",
    lineHeight: "2.1rem",

    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "100%"
  },
  thankYou: {
    // marginLeft: "24px",
    color: theme.palette.common.white,
    fontWeight: 100,
    fontSize: "1rem",
    lineHeight: "1.2",
    // Also allow wrapping if text can get long
    whiteSpace: "normal",
    overflowWrap: "break-word"
  },
  placeDonationText: {
    color: theme.palette.common.white,
    fontWeight: 100,
    fontSize: "2.4rem",
    position: "absolute",
    top: "0",
    left: "0",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  shoutoutCard: {
    width: "90%",
    display: "flex",
    alignItems: "center",

    // If the text inside this card can get very long,
    // you can also add wrapping styles here:
    whiteSpace: "normal",
    overflowWrap: "break-word"
  },
  isNewShoutout: {
    borderBottom: "6px solid white"
  },
  newShoutoutStar: {
    fontFamily: "Oswald",
    color: "white",
    fontSize: "1.75rem",
    fontWeight: "bold",
    textDecoration: "underline",
    fontStyle: "italic"
  },
  nameTile: {
    textAlign: "left"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/ShoutoutCard/styles.js